import React, { Component } from "react";
import "../styles/Guarantee.scss";

export default class Guarantee extends Component {
  render() {
    return (
      <div className="Guarantee">
        <h1>SAMPLE CERTIFICATE OF ABSOLUTION</h1>
        <div className="Guarantee__certificateWrapper">
          <iframe
            title="Absolution Guarantee"
            className="Guarantee__certificate"
            srcDoc='<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><title>Absolution Guarantee</title><style>body {
  font-family: Helvetica;
  background: url("http://absolution-serverless.s3-website-ap-southeast-2.amazonaws.com/images/cert-frame.svg") 0 0 rgb(3, 65, 105);
  background-size: 100% auto;
  background-repeat: no-repeat;
  color: #ffffff;
  font-size: 2vw;
}
h1 {
  font-size: 4.5vw;
  color: rgb(207, 175, 30);
  text-align: center;
  padding: 50px 13vw 12vw;
}
h3 {
  font-size: 2.5vw;
  text-align: center;
}
h4 {
  font-size: 2vw;
  text-decoration: underline;
  line-height:26px;
  margin-bottom: 5px;
}
h5 {
  font-size: 1.6vw;
  font-weight: bold;
  margin-bottom: 5px;
}
.sinDetails {
  border: 2px dotted #ffffff;
  margin: 5vw 13vw 4vw;;
  padding: 20px;
  position: relative;
}
div.ribbon {
  background: url("http://absolution-serverless.s3-website-ap-southeast-2.amazonaws.com/images/ribbon-white.png") 0 0 rgb(3, 65, 105);
  position: absolute;
  height: 118px;
  width:100px;
  right: -10px;
  bottom: -50px;
}
div.signatures {
  padding: 20px;
  grid-template-columns: 1fr 1fr;
  display: grid;
  grid-gap: 5px;
}
div.sigCard {
  position: relative;
  display: flex;
  flex-direction: column;
  text-align: center;
}
div.disclaimer {
  position: absolute;
  text-align:center;
  font-size: 1.2vw;
  bottom: 40px;
  margin: 0 150px;

}</style></head><body><h1>YOUR CERTIFICATE OF ABSOLUTION</h1><h3>Anonymous of Washington</h3><div class="sinDetails"><p>You are hereby granted ABSOLUTION for the sin of Lust</p><br><div id="description"><p>Your particular transgression is:<br>Where to start?
Ranted on twitter about everything.
Pretended to know what I was doing running a country.
Insulted every possible group of people at least once, mostly more.
I could go on but I need to tweet more.</p></div><p>Your ABSOLUTION will last for eternity</p><div class="ribbon"></div></div><div class="signatures"><div class="sigCard"><h4>August 22, 2020</h4><p>On this day of Our Absolver</p></div><div class="sigCard"><h4>The almighty Absolver</h4></div></div><div class="disclaimer"><h5>ALL ABSOLUTIONS come with A FULL GUARANTEE</h5><p>*Simply provide proof that absolution is defective and we will provide a full refund. We are proud to say, no evidence has EVER been furnished to question our absolutions</p></div></body></html>'
          ></iframe>
        </div>
      </div>
    );
  }
}
